import styled from 'styled-components';
import { RouterLink } from '@redux-first-router-link';

import { buttonCSS, media, Row, Column } from '@simplywallst/ui-core';

import type { ButtonProps } from '@simplywallst/ui-core';

export const NewScreener = styled(RouterLink)<ButtonProps>`
  ${buttonCSS}
`;

export const HeadingRow = styled(Row)`
  padding-top: ${({ theme }) => theme.x1space}rem;
  padding-bottom: ${({ theme }) => theme.x2space}rem;
`;

export const Heading = styled('header')`
  color: white;
  padding-top: ${({ theme }) => theme.x2space}rem;
  padding-bottom: ${({ theme }) => theme.x2space}rem;
  button + button {
    margin-left: ${({ theme }) => theme.x1space}rem;
  }
  ${media.mdDown`
		padding-left: ${({ theme }) => theme.x2space}rem;
		padding-right: ${({ theme }) => theme.x2space}rem;
	`};
`;

export const IdeaName = styled('h1')`
  ${({ theme }) => theme.typography.heroStrong}
  margin-bottom: ${({ theme }) => theme.x1space}rem;
  ${media.mdDown`
    margin-top: 0;
  `};
`;

export const NameDescriptionContainer = styled('div')`
  padding-bottom: ${({ theme }) => theme.x2space}rem;
`;

export const SavedViewsColumn = styled(Column)`
  padding-top: ${({ theme }) => theme.x2space}rem;
`;
